import { render, staticRenderFns } from "./TrademarkOppositionForm.vue?vue&type=template&id=98b5a4c4&"
import script from "./TrademarkOppositionForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkOppositionForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkOppositionForm.vue?vue&type=style&index=0&id=98b5a4c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports